var customSelects = document.querySelectorAll('.custom-select');

customSelects.forEach(function(customSelect) {
  var selElmnt = customSelect.querySelector('select');
  var ll = selElmnt.length;

  var selectedOption = selElmnt.options[selElmnt.selectedIndex].innerHTML;

  var selectedDiv = document.createElement("DIV");
  selectedDiv.setAttribute("class", "select-selected");
  var selectedSpan = document.createElement("SPAN");
  selectedSpan.textContent = selectedOption;
  selectedDiv.appendChild(selectedSpan);
  customSelect.appendChild(selectedDiv);

  var optionsDiv = document.createElement("DIV");
  optionsDiv.setAttribute("class", "select-items select-hide");

  for (var j = 0; j < ll; j++) {
    var optionDiv = document.createElement("DIV");
    var optionText = selElmnt.options[j].innerHTML;
    var span = document.createElement("SPAN");
    span.textContent = optionText;
    optionDiv.appendChild(span);

    optionDiv.addEventListener("click", function(e) {
      var s = this.parentNode.parentNode.querySelector("select");
      var h = this.parentNode.previousSibling.querySelector("span");
      for (var i = 0; i < s.length; i++) {
        if (s.options[i].innerHTML == this.textContent) {
          s.selectedIndex = i;
          h.textContent = this.textContent; // Update the span's text content
          var sameAsSelected = this.parentNode.getElementsByClassName("same-as-selected");
          for (var k = 0; k < sameAsSelected.length; k++) {
            sameAsSelected[k].removeAttribute("class");
          }
          this.setAttribute("class", "same-as-selected");
          break;
        }
      }
      h.click();
    });
    optionsDiv.appendChild(optionDiv);
  }

  customSelect.appendChild(optionsDiv);

  selectedDiv.addEventListener("click", function(e) {
    e.stopPropagation();
    closeAllSelect(this);
    this.nextSibling.classList.toggle("select-hide");
    this.classList.toggle("select-arrow-active");
  });
});

function closeAllSelect(elmnt) {
  var x = document.getElementsByClassName("select-items");
  var y = document.getElementsByClassName("select-selected");
  for (var i = 0; i < y.length; i++) {
    if (elmnt == y[i]) {
      continue;
    }
    y[i].classList.remove("select-arrow-active");
    x[i].classList.add("select-hide");
  }
}

document.addEventListener("click", closeAllSelect);





